<div class="d-flex custom-filter-button">
  <span class="txt-blue"
    >Filter
    <img src="assets/images/common/filter.svg" />
  </span>

  <button
    [disabled]="isDisabledClearBtn"
    type="button"
    class="btn clear-btn"
    mat-button
    (click)="$event.stopPropagation(); $event.preventDefault(); clearFilters()"
  >
    CLEAR
  </button>
</div>
